const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDg1LjUgNTEzIDM0MiI+CjxyZWN0IHk9Ijg1LjUiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSI1MTMiIGhlaWdodD0iMzQyIi8+CjxyZWN0IHk9Ijg1LjUiIGZpbGw9IiNjZDFmMmEiIHdpZHRoPSI1MTMiIGhlaWdodD0iMTE0Ii8+CjxyZWN0IHk9IjMxMiIgZmlsbD0iIzFkNDE4NSIgd2lkdGg9IjUxMyIgaGVpZ2h0PSIxMTQiLz4KPC9zdmc+Cg==";
export {
  I as default
};
//# sourceMappingURL=NL-229cf6f0.mjs.map
